module.exports = __webpack_public_path__ + "static/img/process-quality-3.775ee0fd.png";